import React from 'react'

const ResolveNdrIcon = () => {
    return (
        <>
         <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#d8ecfe"
                        d="M285.958 293.127c-12.226-23.743-11.223-51.529 2.683-74.33 13.905-22.8 38.15-36.411 64.855-36.411 1.297 0 2.586.042 3.871.105V47.771l-6.072-1H63.946l-6.02 1v311.603c0 5.788 4.692 10.479 10.479 10.479h257.06z"
                        opacity={1}
                        data-original="#d8ecfe"
                        className=""
                    />
                    <path
                        fill="#c4e2ff"
                        d="M101.473 359.374V47.771H57.926v311.603c0 5.788 4.692 10.479 10.479 10.479h43.546c-5.786 0-10.478-4.692-10.478-10.479z"
                        opacity={1}
                        data-original="#c4e2ff"
                        className=""
                    />
                    <path
                        fill="#4fc123"
                        d="M346.888 0H68.406c-5.788 0-10.479 4.692-10.479 10.479V47.77h299.441V10.479C357.367 4.692 352.675 0 346.888 0z"
                        opacity={1}
                        data-original="#4fc123"
                    />
                    <path
                        fill="#47a920"
                        d="M111.952 0H68.406c-5.788 0-10.479 4.692-10.479 10.479V47.77h43.546V10.479C101.473 4.692 106.165 0 111.952 0z"
                        opacity={1}
                        data-original="#47a920"
                    />
                    <path
                        fill="#8ac9fe"
                        d="M181.392 243.949h-80.316c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h80.316c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                        opacity={1}
                        data-original="#8ac9fe"
                        className=""
                    />
                    <g fill="#8ac9fe">
                        <path
                            d="M277.571 262.457H101.076c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5H279.94a75.31 75.31 0 0 1-2.369-15zM287.419 295.964H101.076c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h194.067z"
                            fill="#8ac9fe"
                            opacity={1}
                            data-original="#8ac9fe"
                            className=""
                        />
                    </g>
                    <path
                        fill="#f6a96c"
                        d="M199.412 179.283c0-23.372 13.682-43.608 33.458-53.121V86.483c0-3.084-2.5-5.584-5.584-5.584H106.66a5.584 5.584 0 0 0-5.584 5.584v97.833c0 3.084 2.5 5.585 5.584 5.585h93.729a58.98 58.98 0 0 1-.977-10.618z"
                        opacity={1}
                        data-original="#f6a96c"
                    />
                    <path
                        fill="#ea9b58"
                        d="M135.538 184.317V86.483c0-3.084 2.5-5.585 5.584-5.585H106.66a5.585 5.585 0 0 0-5.585 5.585v97.833c0 3.084 2.5 5.585 5.585 5.585h34.462a5.584 5.584 0 0 1-5.584-5.584z"
                        opacity={1}
                        data-original="#ea9b58"
                    />
                    <path
                        fill="#fe646f"
                        d="M182.162 123.124h-30.379a3.35 3.35 0 0 1-3.351-3.351V80.899h37.081v38.875c0 1.85-1.5 3.35-3.351 3.35z"
                        opacity={1}
                        data-original="#fe646f"
                    />
                    <path
                        fill="#ffffff"
                        d="M288.641 218.797c6.844-11.223 16.198-20.213 27.113-26.456a58.858 58.858 0 0 0 1.477-13.058c0-32.483-26.426-58.909-58.909-58.909s-58.909 26.426-58.909 58.909 26.426 58.909 58.909 58.909c8.322 0 16.24-1.744 23.424-4.871a77.067 77.067 0 0 1 6.895-14.524z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#f3f0f3"
                        d="M234.366 179.283c0-26.4 17.456-48.799 41.432-56.262a58.696 58.696 0 0 0-17.477-2.647c-32.483 0-58.909 26.427-58.909 58.909 0 32.483 26.426 58.909 58.909 58.909 6.083 0 11.953-.927 17.477-2.647-23.976-7.463-41.432-29.862-41.432-56.262z"
                        opacity={1}
                        data-original="#f3f0f3"
                    />
                    <path
                        fill="#fe7701"
                        d="M286.753 222.087a51.105 51.105 0 0 1-28.432 8.605c-28.347 0-51.409-23.062-51.409-51.409s23.062-51.409 51.409-51.409 51.409 23.062 51.409 51.409a51.126 51.126 0 0 1-4.031 19.953 74.922 74.922 0 0 1 18.411-11.005c.396-2.929.62-5.912.62-8.948 0-36.618-29.791-66.409-66.409-66.409s-66.409 29.791-66.409 66.409 29.791 66.409 66.409 66.409c7.289 0 14.3-1.198 20.867-3.377a76.207 76.207 0 0 1 7.565-20.228z"
                        opacity={1}
                        data-original="#fe7701"
                        className=""
                    />
                    <path
                        fill="#8ac9fe"
                        d="M287.624 186.783h-29.303a7.5 7.5 0 0 1-7.5-7.5v-37.097a7.5 7.5 0 0 1 7.5-7.5c4.143 0 7.5 3.357 7.5 7.5v29.597h21.803c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
                        opacity={1}
                        data-original="#8ac9fe"
                        className=""
                    />
                    <g fill="#8ac9fe">
                        <path
                            d="M237.495 430.649 183.3 380.416a28.427 28.427 0 0 1-9.092 12.026l54.88 50.868a28.355 28.355 0 0 1 8.407-12.661zM131.739 382.715l-82.322 76.303a28.48 28.48 0 0 1 9.956 11.225l82.424-76.398a28.478 28.478 0 0 1-10.058-11.13zM462.583 459.018l-85.948-79.664-7.129 13.845 83.121 77.044a28.473 28.473 0 0 1 9.956-11.225zM330.192 379.033l-55.687 51.616a28.366 28.366 0 0 1 8.407 12.661l54.41-50.432z"
                            fill="#8ac9fe"
                            opacity={1}
                            data-original="#8ac9fe"
                            className=""
                        />
                    </g>
                    <circle
                        cx="478.013"
                        cy="482.711"
                        r="29.289"
                        fill="#0593fc"
                        opacity={1}
                        data-original="#0593fc"
                    />
                    <path
                        fill="#0182fc"
                        d="M474.558 482.711c0-11.539 6.675-21.515 16.372-26.289-3.897-1.919-8.28-3-12.917-3-16.176 0-29.289 13.113-29.289 29.289S461.837 512 478.013 512c4.637 0 9.02-1.082 12.917-3-9.697-4.774-16.372-14.75-16.372-26.289z"
                        opacity={1}
                        data-original="#0182fc"
                    />
                    <circle
                        cx="33.987"
                        cy="482.711"
                        r="29.289"
                        fill="#0593fc"
                        opacity={1}
                        data-original="#0593fc"
                    />
                    <path
                        fill="#0182fc"
                        d="M30.532 482.711c0-11.539 6.675-21.515 16.372-26.289-3.897-1.919-8.28-3-12.917-3-16.176 0-29.289 13.113-29.289 29.289C4.698 498.887 17.811 512 33.987 512c4.637 0 9.02-1.082 12.917-3.001-9.697-4.773-16.372-14.75-16.372-26.288z"
                        opacity={1}
                        data-original="#0182fc"
                    />
                    <circle
                        cx={256}
                        cy="452.019"
                        r="29.289"
                        fill="#0593fc"
                        opacity={1}
                        data-original="#0593fc"
                    />
                    <path
                        fill="#0182fc"
                        d="M252.545 452.019c0-11.539 6.675-21.515 16.372-26.289A29.156 29.156 0 0 0 256 422.729c-16.176 0-29.289 13.113-29.289 29.289s13.113 29.289 29.289 29.289c4.637 0 9.02-1.082 12.917-3.001-9.697-4.772-16.372-14.748-16.372-26.287z"
                        opacity={1}
                        data-original="#0182fc"
                    />
                    <circle
                        cx="157.002"
                        cy="370.009"
                        r="29.289"
                        fill="#fe646f"
                        opacity={1}
                        data-original="#fe646f"
                    />
                    <path
                        fill="#fd4755"
                        d="M154.012 370.008c0-11.446 6.569-21.351 16.14-26.17a29.158 29.158 0 0 0-13.15-3.12c-16.176 0-29.289 13.113-29.289 29.289s13.113 29.289 29.289 29.289a29.16 29.16 0 0 0 13.15-3.119c-9.57-4.817-16.14-14.723-16.14-26.169z"
                        opacity={1}
                        data-original="#fd4755"
                    />
                    <path
                        fill="#fe646f"
                        d="m358.461 416.833 63.462-123.248c26.375-51.222-10.813-112.199-68.427-112.199-57.614 0-94.802 60.977-68.427 112.199l63.462 123.248c2.079 4.037 7.852 4.037 9.93 0z"
                        opacity={1}
                        data-original="#fe646f"
                    />
                    <path
                        fill="#fd4755"
                        d="M328.512 293.584c-22.88-44.435 2.079-96.201 46.706-109.142-6.816-1.977-14.087-3.057-21.721-3.057-57.614 0-94.802 60.977-68.427 112.199l63.462 123.248c2.079 4.037 7.851 4.037 9.93 0l16.756-32.542z"
                        opacity={1}
                        data-original="#fd4755"
                    />
                    <circle
                        cx="353.496"
                        cy="261.711"
                        r="46.069"
                        fill="#fb2b3a"
                        opacity={1}
                        data-original="#fb2b3a"
                    />
                    <circle
                        cx="353.496"
                        cy="261.711"
                        r="22.277"
                        fill="#ffffff"
                        opacity={1}
                        data-original="#ffffff"
                    />
                </g>
            </svg>
          
        </>
    )
}

export default ResolveNdrIcon